import { all, takeEvery, put, call, select } from 'redux-saga/effects'
import { REQUEST_MESSAGES_LIST, REQUEST_DELETE_MESSAGE } from './constants'
import {setMessagesList, setMessagesLoading} from './actions'
import MessagesClient from '../../apiClient/MessagesClient'

const messagesClient = new MessagesClient()

function* getAll({ payload: { page, userFilter, roomFilter, sortBy } }) {
    try {
        yield put(setMessagesLoading())
        const { messages, pagination } = yield call(messagesClient.getAll, page, userFilter, roomFilter, sortBy)
        yield put(setMessagesList({ messages, pagination }))
    } catch (e) {
        console.error(e)
        console.warn(e)
    }
}

function* deleteMessage({ payload: { messageId, userFilter, roomFilter } }) {
    try {
        const { messageDeleted } = yield call(messagesClient.deleteMessage, messageId)
        const page = yield select(({ messages }) => messages.pagination.page_number)

        yield getAll({ payload: { page, userFilter, roomFilter } })
    } catch (e) {
        console.warn(e)
    }
}

export default function* appSagas() {
    yield all([takeEvery(REQUEST_MESSAGES_LIST, getAll), takeEvery(REQUEST_DELETE_MESSAGE, deleteMessage)])
}
